import { Link } from "react-router-dom"
import { Github, Twitter, Linkedin } from "lucide-react"

const navigation = {
  main: [
    { name: "Explore", href: "/explore" },
    { name: "Tags", href: "/tags" },
    { name: "About", href: "/about" },
    { name: "Contact", href: "/contact" },
    { name: "Privacy", href: "/privacy" },
    { name: "Terms", href: "/terms" },
  ],
  categories: [
    { name: "Tutorials", href: "/category/tutorials" },
    { name: "News", href: "/category/news" },
    { name: "Libraries", href: "/category/libraries" },
    { name: "Performance", href: "/category/performance" },
    { name: "UI/UX", href: "/category/ui-ux" },
    { name: "Career", href: "/category/career" },
  ],
  social: [
    { name: "Twitter", href: "https://twitter.com/reactnativenews", icon: Twitter },
    { name: "GitHub", href: "https://github.com/reactnativenews", icon: Github },
    { name: "LinkedIn", href: "https://linkedin.com/company/reactnativenews", icon: Linkedin },
  ],
}

export function Footer() {
  return (
    <footer className="border-t border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-950">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center space-x-2">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-indigo-600 text-white">
                <svg viewBox="0 0 32 32" className="w-6 h-6">
                  <g transform="translate(16, 16)">
                    <ellipse cx="0" cy="0" rx="9" ry="3.6" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.85" transform="rotate(-30)" />
                    <ellipse cx="0" cy="0" rx="9" ry="3.6" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.85" transform="rotate(30)" />
                    <ellipse cx="0" cy="0" rx="9" ry="3.6" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.85" transform="rotate(90)" />
                    <circle cx="0" cy="0" r="1.8" fill="currentColor" />
                  </g>
                </svg>
              </div>
              <span className="font-bold text-gray-900 dark:text-white">React Native News</span>
            </Link>
            <p className="mt-4 max-w-xs text-sm text-gray-500 dark:text-gray-400">
              The community-driven platform for React Native developers. Share knowledge, learn from others, and stay up-to-date with the latest in
              mobile development.
            </p>
            {/* Social links */}
            <div className="mt-6 flex space-x-4">
              {navigation.social.map(item => (
                <a
                  key={item.name}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
                >
                  <span className="sr-only">{item.name}</span>
                  <item.icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white">Navigation</h3>
            <ul className="mt-4 space-y-2">
              {navigation.main.map(item => (
                <li key={item.name}>
                  <Link to={item.href} className="text-sm text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white">Categories</h3>
            <ul className="mt-4 space-y-2">
              {navigation.categories.map(item => (
                <li key={item.name}>
                  <Link to={item.href} className="text-sm text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 border-t border-gray-200 pt-8 dark:border-gray-800">
          <p className="text-center text-sm text-gray-400">&copy; {new Date().getFullYear()} Nexus Development, LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}
